<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <a-card
      v-if="open_maintain_service==='YES'"
      :bordered="false"
      title="延保设置"
    >
      <a-button
        slot="extra"
        class="mr-10"
        @click="handleReset"
      >
        重置
      </a-button>
      <a-button
        slot="extra"
        type="primary"
        :loading="confirmLoading"
        @click="handleConfirm"
      >
        保存
      </a-button>
      <div class="m-20">说明：保修期内才可以购买延保，保修期以打印时间为起始计算</div>
      <!-- 表单 -->
      <a-form-model
        ref="form"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <div
          v-for="(it, ind) in setting"
          :key="'setting' + ind"
        >
          <a-form-model-item :label="it['brand_name']">
            <a-button type="primary" size="small" @click="addOption(ind, it)">添加选项</a-button>
            <a-input-group compact v-for="(item, index) in it['item']" :key="'it' + ind + index">
              <a-input-number :min="1" style="width: 100px; text-align: center" v-model="item.setting" />
              <a-select style="width: 60px" v-model="item.unit">
                <a-select-option value="YEAR">
                  年
                </a-select-option>
                <a-select-option value="MONTH">
                  月
                </a-select-option>
                <a-select-option value="DAY">
                  日
                </a-select-option>
              </a-select>
              <a-input-number :min="0.01" style="width: 140px; text-align: center" v-model="item.price" :precision="2" />
              <a-input style="width: 50px; text-align: center;" value="元" disabled />
              <a-button style="margin: 0 10px; border-radius: 4px" type="danger" icon="delete" @click="delOption(ind, index)">删除</a-button>
            </a-input-group>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-card>
    <a-result v-else status="403" title="延保服务暂未开通" sub-title="无法使用，请联系业务经理进行升级"/>
  </a-spin>
</template>

<script>
import { getMaintainPre, postMaintainSetting, checkService } from '@/api/maintain'
import { deepClone } from '@/utils'

const defaultConfig = {
  setting_id: '', // 设置ID(新增为空),
  setting: '', // 值,
  unit: 'YEAR', // 单位,
  price: '', // 价格（基础保修价格为0）,
  is_normal: 'NO', // 是否基础保修设置 (YES-是 NO-否）
  brand_id: 0
}

export default {
  name: 'MaintainSetting',
  components: {},
  data() {
    return {
      spinning: false,
      open_maintain_service: 'YES',
      confirmLoading: false,
      labelCol: { xxl: { span: 2 }, xl: { span: 3 }, lg: { span: 4 }, md: { span: 5 }, sm: { span: 7 }, xs: { span: 8 } },
      wrapperCol: { xxl: { span: 22 }, xl: { span: 21 }, lg: { span: 20 }, md: { span: 19 }, sm: { span: 17 }, xs: { span: 16 } },
      formData: {},
      setting: []
    }
  },
  created() {
    this.checkService()
    this.getPre()
  },
  methods: {
    // 预加载
    getPre() {
      getMaintainPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.setting = data
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 点击 确认 按钮
    handleConfirm() {
      for (let i = 0; i < this.setting.length; i++) {
        for (let j = 0; j < this.setting[i]['item'].length; j++) {
          if (!this.setting[i]['item'][j].setting || !this.setting[i]['item'][j].unit || !this.setting[i]['item'][j].price) {
            this.$message.error('还有字段未填写，请检查！')
            return
          }
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postEdit()
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 点击 取消 按钮
    handleReset() {
      this.getPre()
    },
    // 保存延保设置
    postEdit() {
      console.log(this.setting)
      this.confirmLoading = true
      const setting = [...this.setting]
      postMaintainSetting({ setting })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.getPre()
          }
        })
        .catch((e) => {
          this.$message.error('保存延保设置失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 添加选项
    addOption(index, it) {
      const cnfObj = deepClone(defaultConfig)
      cnfObj.brand_id = it['brand_id']
      if (it['item'].length < 3) {
        it['item'].push(Object.assign({}, defaultConfig, cnfObj))
      } else {
        this.$message.warning('最多只能添加三个选项')
      }
    },
    // 删除选项
    delOption(ind, index) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          this.setting[ind]['item'].splice(index, 1)
        }
      })
    },
    // 检查服务
    checkService() {
      this.spinning = true
      checkService()
        .then((res) => {
          if (res.code === 200) {
            this.open_maintain_service = res.data.open_maintain_service
          } else {
            this.$message.error('检查服务失败')
          }
        })
        .catch((e) => {
          this.$message.error('检查服务失败')
        })
        .finally(() => {
          this.spinning = false
        })
    }
  }
}
</script>
